import React, { Component } from 'react'

import arrowFIcon from "../images/ARROW-F.svg"

export default class NewsletterForm extends Component {
    constructor(props) {
        super(props);
        this.state = {value: ''};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        alert(`fixme: ${this.state.value}`);
    }

    render() {
        return (<div className="email-subscription">
            <div className="div-block-24">
                <div className="div-block-124 w-hidden-medium w-hidden-small w-hidden-tiny"></div>
                <h1 className="newsletter">
                    <strong className="section-headline-big">
                        For more stories of business pioneers, subscribe to our newsletter
                    </strong>
                </h1>
                <div className="email smaller">
                    <div className="form-block">
                        <form
                            className="form"
                            action="https://startupguide.eo.page/g4t6f"
                            method="get"
                            id="mc-embedded-subscribe-form"
                            name="mc-embedded-subscribe-form"
                            target="_blank"
                            noValidate
                        >
                            <div className="div-block-9">
                                <input
                                    type="email"
                                    name="EmailAddress"
                                    id="mce-EMAIL"
                                    className="text-field black w-input"
                                    style={{ color: '#000' }}
                                    maxLength={256}
                                    placeholder="Your email *"
                                    value={this.state.value}
                                    onChange={this.handleChange}
                                    required
                                />
                                <div className="div-block-10 w-clearfix">
                                    <input
                                        type="submit"
                                        id="mc-embedded-subscribe"
                                        data-wait="Please wait..."
                                        className="button small secondary w-button"
                                    />
                                    <img alt="" src={arrowFIcon} width={10} className="image-40" />
                                </div>
                            </div>
                        </form>
                        <div className="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div className="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}
